import React from 'react';
import { Routes, Route, BrowserRouter as Router } from 'react-router-dom';
import LoginForm from './component/LoginForm';
import ProtectedRoute from './component/ProtectedRoute';
import SuperAdminHome from './component/SuperAdminHome';
import AdminList from './component/AdminList'
import OperatorList from './component/OperatorList';
import CustomersList from './component/CustomersList';
import AddAdminForm from './component/AddAdminForm';
import AddOperatorForm from './component/AddOperatorForm';
import AddCustomerForm from './component/AddCustomerForm';
import PageNotFound from './component/PageNotFound';
import AdminHome from './component/AdminHome';
import OperatorHome from './component/OperatorHome';
import Packages from './component/Package';
import ChangePassword from './component/ChangePassword';
import Customer from './component/Customer';
import WalletHistory from './component/WalletHistory';
import Home from './component/Home';
import AllPackages from './component/AllPackage'
import PlanMapping from './component/PlanMapping';
import PlanMappingByOperator from './component/PlanMappingByOperator';
import AdminPreRegister from './component/PreRegister/AdminPreRegister';
import AddStelfiberDevice from './component/AddStelfiberDevice';
import OperatorChannelManager from './component/OperatorChannelMapping';
// import PreRegister from './component/PreRegister/PreRegister';
// import Success from './component/PreRegister/Success';


function App() {
  return (
    <Router>
      <Routes>
        <Route path='/' element={<Home />} />

        <Route path="/login" element={<LoginForm />} />
        {/* <Route path="/all-packages" element={<AllPackages />} />
        <Route path="/pre-register" element={<PreRegister/>}/>
        <Route path="/success" element={<Success/>}/> */}

        <Route element={<ProtectedRoute allowedRoles={['superadmin', 'admin', 'operator']} />}>
          <Route path="/add-customer" element={<AddCustomerForm />} />
          <Route path="/customers" element={<CustomersList />} />
          <Route path="/change-password" element={<ChangePassword />} />
          <Route path="/customer/:id" element={<Customer />} />
          {/* <Route path="/packages" element={<Packages />} /> */}
          <Route path="/wallet-history" element={<WalletHistory />} />
          <Route path="/operator-channel-mapping" element={<OperatorChannelManager />} />
          
        </Route>

        <Route element={<ProtectedRoute allowedRoles={['superadmin', 'admin']} />}>
          <Route path="/add-operator" element={<AddOperatorForm />} />
          <Route path="/operators" element={<OperatorList />} />
          <Route path="/assign-plans" element={<PlanMapping />} />
          <Route path="/assign-plans/:id" element={<PlanMappingByOperator />} />
          <Route path='/add-stelfiber-device' element={<AddStelfiberDevice />} />
        </Route>

        <Route element={<ProtectedRoute allowedRoles={['operator']} />}>
          <Route path="/operator" element={<OperatorHome />} />
        </Route>

        <Route element={<ProtectedRoute allowedRoles={['admin']} />}>
          <Route path="/admin" element={<AdminHome />} />
        </Route>

        <Route element={<ProtectedRoute allowedRoles={['superadmin']} />}>
          <Route path="/add-admin" element={<AddAdminForm />} />
          <Route path="/admins" element={<AdminList />} />
          <Route path="/superadmin" element={<SuperAdminHome />} />
          <Route path="/admin-prereg" element={<AdminPreRegister/>}/>
        </Route>

        {/* ✅ Fallback 404 */}
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
